import { getObjectTypeNamePlural } from 'marketing-platform-lib/utils/objectName';
/**
 * Creates an association group with fetched CRM objects.
 * This is going to be used to render associations that are not coming from the CRM.
 */
export function createAssociationGroup({
  crmObjects,
  crmObjectTypeDefinitionsForPortal,
  fromObjectTypeId,
  toObjectTypeId
}) {
  const fromCrmObjectTypeDefinition = crmObjectTypeDefinitionsForPortal.find(definition => definition.objectTypeId === fromObjectTypeId);
  const toCrmObjectTypeDefinition = crmObjectTypeDefinitionsForPortal.find(definition => definition.objectTypeId === toObjectTypeId);
  if (!fromCrmObjectTypeDefinition || !toCrmObjectTypeDefinition) {
    return undefined;
  }
  return {
    associationDefinitions: [],
    associatedObjects: crmObjects,
    crmDefined: false,
    fromCrmObjectTypeDefinition,
    fromObjectTypeId,
    toCrmObjectTypeDefinition,
    toObjectTypeId,
    objectTypeName: getObjectTypeNamePlural({
      objectTypeId: toCrmObjectTypeDefinition.objectTypeId,
      textTransform: 'capitalize',
      typeDefinition: toCrmObjectTypeDefinition
    })
  };
}